import React, { Component } from "react";
import { FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import Spinner from "../../base/features/micro/Spinner";
import Empty from "../../base/features/blocks/Empty";
import OrderBlock from "../../base/features/blocks/OrderBlock";
import { apiService } from "../../base/utils/service";
import InfiniteScroll from "react-infinite-scroll-component";
import { isSiteDomain } from "../../settings/domainManager";

class Orders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: null,
    };
  }
  componentDidMount() {
    this.getOrders();
  }
  getOrders() {
    apiService(
      `v1/users/current/orders${isSiteDomain ? "?shop=domain" : ""}`
    ).then((data) => {
      if (data) {
        this.setState({
          orders: data.results,
          hasMoreOrders: data.next ? true : false,
          nextOrders: data.next,
        });
      }
    });
  }
  fetchMoreOrders() {
    apiService(this.state.nextOrders, "get").then((data) => {
      if (data) {
        var newOrders = this.state.orders;
        newOrders = newOrders.concat(data.results);
        this.setState({
          orders: newOrders,
          hasMoreOrders: data.next ? true : false,
          nextOrders: data.next,
        });
      }
    });
  }

  render() {
    return (
      <div className="container-fluid">
        <header
          className="row mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0" }}
        >
          <div className="col-auto align-self-center px-0">
            <Link to={isSiteDomain ? "/" : "/profile"}>
              <FiChevronRight size="26" className="" />
            </Link>
          </div>
          <div className="col align-self-center text-center px-0">
            <h1 className="fs-5 fw-bolder mb-0">سفارش های من</h1>
          </div>
        </header>
        <body style={{ marginTop: "80px", marginBottom: "80px" }}>
          {this.state.orders ? (
            <InfiniteScroll
              dataLength={this.state.orders.length}
              next={() => this.fetchMoreOrders()}
              hasMore={this.state.hasMoreOrders}
              className="row mx-0 px-0"
              loader={<Spinner />}
            >
              {this.state.orders.length === 0 ? (
                <Empty text={"سفارشی ثبت نشده است."} />
              ) : (
                this.state.orders.map((order, o) => (
                  <OrderBlock order={order} />
                ))
              )}
            </InfiniteScroll>
          ) : (
            <Spinner />
          )}
        </body>
      </div>
    );
  }
}

export default Orders;
